import { ISplitDetailOrderParam, type ISplitDetailOrder } from '../../../types/air-splitting/bill-management/splitDetailOrders';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 账单管理 - 分账明细清单
 */
export async function querySplitDetailOrders(param: ISplitDetailOrderParam) {
  let data = [] as ISplitDetailOrder[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISplitDetailOrderParam;

  try {
    const { code, context, message } = await Http.get<{ data: ISplitDetailOrder[]; total: number }>(`${hostUrl}/pay/order/sub-order-page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISplitDetailOrder[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

